import { useRef, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import SwiperCore from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Initialize Swiper modules
SwiperCore.use([Navigation, Pagination, Autoplay]);

const services = [
  {
    number: "1",
    title: "Turnkey Construction",
    description:
      "From layout to handover, we manage every stage—planning, procurement, manpower, construction, and finishing.",
  },
  {
    number: "2",
    title: "Society Redevelopment",
    description:
      "We work closely with housing societies and consultants to navigate legal, logistical, and architectural aspects with minimal disruption.",
  },
  {
    number: "3",
    title: "RCC & Structural Work",
    description:
      "Expertise in concrete frameworks, steel structure integration, formwork systems, and load calculations.",
  },
  {
    number: "4",
    title: "Interior Fit-outs & Renovations",
    description:
      "Smart and functional renovation of existing buildings and spaces with tailored design implementation.",
  },
  {
    number: "5",
    title: "Project Management",
    description: "Cost control, BOQs, daily audits, and coordination.",
  },
];

export default function CoreServices() {
  const nextButtonRef = useRef(null);
  const swiperInstanceRef = useRef(null);

  useEffect(() => {
    // Update navigation when swiper instance and button are available
    if (swiperInstanceRef.current && nextButtonRef.current) {
      swiperInstanceRef.current.navigation.update();
    }
  }, []);

  return (
    <section className="bg-[#153280] text-white py-20 relative services-bg overflow-hidden">
      <div className="text-center">
        <h2 data-aos="fade-up" className="text-6xl service-bg-title">
          Our Core Services
        </h2>
      </div>

      <div className="relative px-6">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={28}
          slidesPerView={1}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            280: { slidesPerView: 1 },
            640: { slidesPerView: 1.5 },
            980: { slidesPerView: 3 },
            1440: { slidesPerView: 4.5 },
          }}
          navigation={{
            nextEl: nextButtonRef.current,
          }}
          pagination={{ clickable: true, type: "progressbar" }}
          onSwiper={(swiper) => {
            swiperInstanceRef.current = swiper;
          }}
          className="mySwiper"
        >
          {services.map((service, index) => (
            <SwiperSlide key={index}>
              <div
                className="h-[420px] bg-white text-black p-6 py-8 rounded-lg shadow-md"
                data-aos="fade-up"
                data-aos-delay={`${200 + index * 100}`}
              >
                <div className="service-number">{service.number}</div>
                <h3 className="service-number-heading">{service.title}</h3>
                <p className="service-number-para">{service.description}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Next Arrow Button */}
        {/* <button
          ref={nextButtonRef}
          className="absolute service-button-arrow top-1/2 right-4 transform -translate-y-1/2 bg-white text-black p-2 rounded-full shadow-md hover:bg-gray-100 z-20"
        >
          <ArrowRight size={26} />
        </button> */}
      </div>
    </section>
  );
}